<!-- @format -->

<template>
    <v-dialog :model-value="visible" persistent>
        <img :src="images.common.loader" class="mx-auto" style="width: 160px; height: 160px;" alt="..." />
        <div v-if="showProgress" class="mx-auto" style="width: 320px;">
            <v-progress-linear color="secondary" height="10" :model-value="progress" striped></v-progress-linear>
        </div>
    </v-dialog>
</template>
<script setup>
import { onBeforeUnmount,ref, watch } from 'vue'

import images from '@/data/images'

const props = defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    showProgress: {
        type: Boolean,
        default: false
    }
})

const progress = ref(0)
var interval

watch(() => props.visible, (newValue, oldValue) => {
    if (newValue && oldValue != newValue) {
        /** Simulate a loader */
        let e = 2.8
        if (!interval) {
            interval = setInterval(() => {
                progress.value = parseInt(Math.log(e))
                e = Math.pow(e, 1.2)
                if (progress.value > 100) {
                    progress.value = 100
                }
            }, 500)
        }
    }
    else {
        if (interval) {
            clearInterval(interval)
            interval = null
        }
    }
})

onBeforeUnmount(() => {
    if (interval) {
        clearInterval(interval)
        interval = null
    }
    progress.value = 100
})
</script>
